import { QueryClient, QueryClientConfig } from '@tanstack/react-query'

const queryClientDefault = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      staleTime: 5 * 60 * 1000 // Dữ liệu sẽ "tươi" trong 5 phút
    }
  }
})

export type TActionFetch<T> = (...args: any[]) => Promise<T>

export interface IQueryOption extends QueryClientConfig {}

export const generateKeysFromUrlWithMethod = (method: string, url: string) => {
  const segments = url.split('/').filter(Boolean)
  if (segments.length === 0) return method.toLowerCase()
  return `${method.toLowerCase()}${segments[segments.length - 1][0].toUpperCase()}${segments[segments.length - 1].slice(1)}`
}

type TQyeryKey = Parameters<QueryClient['fetchQuery']>[0]['queryKey']

export class ReactQueryHandle {
  _client: QueryClient
  constructor(client?: QueryClient) {
    this._client = client || queryClientDefault
  }

  withReactQueryFetch = <T>(queryKeys: TQyeryKey, action: TActionFetch<T>, options?: IQueryOption) => {
    return this._client.fetchQuery({
      queryKey: queryKeys,
      queryFn: action,
      ...options
    })
  }

  withReactQueryFetchAutoKey = <T>(method: string, url: string, action: TActionFetch<T>, options?: IQueryOption) => {
    const queryKeys = [generateKeysFromUrlWithMethod(method, url)]
    return this.withReactQueryFetch(queryKeys, action, options)
  }
}
